// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + {"25":"36af7271d9dfea527b61","484":"ac1c93b129b4ee7300a2"}[chunkId] + ".js";
};